export default (app) => {
  if (app.settings.noClientCache) return;

  app.database.on("init", ({ collection, db, memdb }) => {
    const id = `dbStorage${collection.contentType.machinename}`;
    let data = [];
    const save = () => app.storage.setItemDebounce({ id, value: data, delay: 500 });

    collection.on("save", -1000, (query) => {
      if (!memdb && query.data) {
        const position = data.findIndex(({ _id }) => _id === query.id);
        if (position !== -1) data.splice(position, 1);
        data.push(query.data);
      }
      save();
    });
    collection.on("delete", -1000, (query) => {
      if (!memdb) data = data.filter(({ _id }) => _id !== query.id);
      save();
    });
    collection.on("saveStorage", -1000, save);

    collection.on("init", 1000, (query) =>
      app.storage.getItem({ id }).then(({ value }) => {
        data = value || [];
        if (memdb) {
          db.dbArray = data;
          return query;
        }
        return { ...query, storageData: data };
      }),
    );

    collection.on("clearCache", () => {
      data = [];
      app.storage.setItemDebounce({ id, value: data, delay: 0 });
      if (memdb) {
        db.dbArray = data;
        db.dbIndex = {};
      }
    });
  });
};
